// import React from 'react'
import { Calendar, Clock, MapPin } from "lucide-react";
// import Header from "../components/Header";
import { useNavigate, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getEventsDetails } from "../api/events.ts";
import { formatDateToFrench } from "../utils/dateUtils.ts";
import EventPageSkeleton from "../components/skeletons/EventPageSkeleton.tsx";
import { formatWithThousandsSeparator } from "../utils/currency.ts";
import { useEffect, useState } from "react";
import GoBackHeader from "../components/GoBackHeader.tsx";
import dayjs from 'dayjs';

interface Event {
  eventImage: string;
  title: string;
  reference: string;
  shortDescription: string;
  eventDate: string;
  googleMap: string;
  eventPlace: string;
  longDescription: string;
  minAmount: string;
  maxAmount: string;
  services:[];
}

export default function Event() {
  const { eventReference } = useParams();
  const [event, setEvent] = useState<Event | null>(null);

  const { data, isLoading } = useQuery({
    queryKey: ["eventsDetails", eventReference],
    queryFn: () => getEventsDetails(eventReference || ""),
    staleTime: 5000,
  });

  useEffect(() => {
    if (data) setEvent(data);
  }, [data]);

  useEffect(() => {
    return () => {
      setEvent(null);
    };
  }, []);
  const navigate = useNavigate();

  const navigateToTickets = () => {
    // @ts-ignore
    if(event?.services?.length >= 1){
      navigate("/tickets", {
        state: {
          event
        }
      });
    }
  }

    // @ts-ignore
  return (
    <>
      <div
        style={{
          backgroundImage: `url('/pattern-white.svg')`,
          backgroundSize: "auto",
          objectFit: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
        className="min-h-screen "
      >
        {isLoading ? (
          <EventPageSkeleton />
        ) : (
          <>
            {/*Header Image*/}
            <div
              style={{
                backgroundImage: `url(${event?.eventImage || "https://placehold.jp/150x150.png"})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
              className="h-60 p-4 "
            >
              <GoBackHeader onBackPress={() => navigate("/")} />
            </div>
            <div className="p-4">
              <div className="text-[#194E6E] text-3xl font-bold">
                {event?.title}
              </div>

              <div className="text-xl my-2 font-thin">
                {event?.shortDescription}
              </div>

              <div className="flex flex-col">
                <div className="flex space-x-2 items-center my-2">
                  <Calendar className="w-8 h-8" />
                  <span className="text-[#4B4E50] text-lg font-bold">
                    {formatDateToFrench(event?.eventDate)}
                  </span>
                </div>

                <div className="flex space-x-2 items-center my-2">
                  <Clock className="w-8 h-8" />
                  <span className="text-[#4B4E50] text-lg font-bold">
                    {dayjs(event?.eventDate).format('HH:mm')}
                    {/*{getHourFromDate(event?.eventDate)}*/}
                  </span>
                </div>

                <a href={`${event?.googleMap}`}
                   onClick={(e) => !event?.googleMap && e.preventDefault()}
                   target="_blank"
                   className="flex text-primary space-x-2 items-center my-2"
                >
                  <MapPin className="w-8 h-8" />
                  <span className="text-lg font-bold">
                    {event?.eventPlace}
                  </span>
                </a>

                <span className="text-xl mt-6 font-normal">
                  À propos de cet évènement
                </span>

                <div className="text-xl mb-28 mt-2 font-thin bg-white rounded shadow p-4">
                  {event?.longDescription}{" "}
                </div>
              </div>
            </div>
            <div className="fixed bottom-0 left-0 right-0 bg-white p-4 shadow-lg rounded-t-2xl z-20">
              <div className="flex flex-col items-center">
                <span className="text-black text-lg font-bold mb-2">
                  {/*// @ts-ignore*/}
                  {event?.services?.length >= 1 ? event?.minAmount === event?.maxAmount
                      // @ts-ignore
                      ? `${event?.minAmount === 0 ? 'Gratuit' : formatWithThousandsSeparator(event?.minAmount)} ${event?.minAmount === 0 ? '' : 'XOF'}`
                      // @ts-ignore
                      : `${event?.minAmount === 0 ? 'Gratuit' :formatWithThousandsSeparator(event?.minAmount)} ${event?.minAmount === 0 ? '' : 'XOF'} - ${formatWithThousandsSeparator(event?.maxAmount || 0)} XOF` : ''}
                </span>
                <button
                  className={`${event?.services && event?.services?.length >= 1 ? 'bg-third' : 'bg-gray-300'}  text-white text-center font-semibold py-3 px-6 rounded-full w-full max-w-xs`}
                  onClick={navigateToTickets}
                >
                  {/*// @ts-ignore*/}
                  {event?.services?.length >= 1 ? 'Choix de tickets' : 'Aucun ticket disponible pour le moment '}
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}
